import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { environment } from "src/environments/environment";
import { Observable } from "rxjs";
import { AuthService } from "./auth.service";

@Injectable({
  providedIn: "root"
})
export class RestaurantService {
  constructor(private http: HttpClient, private authService: AuthService) {}

  public requestReserv(data) {

    let options = { headers: null };
    const headers = new HttpHeaders();
    options.headers = headers.set(
      "Authorization",
      `Bearer ${this.authService.getToken()}`
    );

    return this.http.post(`${environment.API_BASE}api/restaurante/reserva`, data);
  }
  public requestReservClient(data) {

    let options = { headers: null };
    const headers = new HttpHeaders();
    options.headers = headers.set(
      "Authorization",
      `Bearer ${this.authService.getToken()}`
    );

    return this.http.post(`${environment.API_BASE}api/restaurante/reserva/cliente`, data);
  }
  public requestReservSame(data) {

    let options = { headers: null };
    const headers = new HttpHeaders();
    options.headers = headers.set(
      "Authorization",
      `Bearer ${this.authService.getToken()}`
    );

    return this.http.post(`${environment.API_BASE}api/restaurante/reserva/mesmo-restaurante`, data);
  }

  public requestReservBrochure(data) {

    let options = { headers: null };
    const headers = new HttpHeaders();
    options.headers = headers.set(
      "Authorization",
      `Bearer ${this.authService.getToken()}`
    );

    return this.http.post(`${environment.API_BASE}api/informativo/reserva`, data);
  }


  public async getRaceInfo(filaId, motoristaId): Promise<Observable<any>> {
    let options = { headers: null };
    const headers = new HttpHeaders();
    options.headers = headers.set(
      "Authorization",
      `Bearer ${await this.authService.getToken()}`
    );
    return this.http.get(`${environment.API_BASE}api/fila/informacoes?filaId=${filaId}&motoristaId${motoristaId}`, options);
  }
}
